var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMilleisoleLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "97.6535mm",
    height: "88.3881mm",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 3616.71 3273.55",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#4D897C",
    transform: "matrix(0.645633 0.716913 -0.657008 0.809505 150.84 1167.29)",
    rx: 102.28,
    ry: 157.35
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#4D897C",
    transform: "matrix(0.343525 0.538132 -0.797435 0.438201 678.843 422.373)",
    rx: 102.28,
    ry: 157.35
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#4D897C",
    transform: "matrix(-0.209975 0.602914 -0.837787 -0.355015 2759.37 301.947)",
    rx: 102.28,
    ry: 157.35
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#B2B3B3",
    fillRule: "nonzero",
    d: "M1211.05 157.96c-13.82,-20.54 -2.82,-45.61 24.57,-55.97 27.39,-10.36 60.81,-2.11 74.62,18.43l-99.2 37.54zm204.92 304.58l-204.92 -304.58 99.2 -37.54 204.92 304.58 -99.2 37.54zm99.2 -37.54c13.82,20.54 2.82,45.61 -24.57,55.97 -27.39,10.36 -60.81,2.11 -74.62,-18.43l99.2 -37.54z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#4D897C",
    d: "M2032.44 49.95c2.24,31.64 -57.23,45.94 -126.77,46.28 -69.54,0.34 -148.54,-21.97 -150.78,-53.61 -2.24,-31.64 70.69,-42.26 140.23,-42.6 69.54,-0.34 135.07,18.3 137.31,49.94z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#6FB5B4",
    transform: "matrix(0.266708 0.687189 -1.14849 0.284912 1260.65 139.187)",
    rx: 102.28,
    ry: 157.35
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#B2B3B3",
    d: "M1796.84 502.08c915.86,260.12 1256.93,660.65 1394.34,1084.1 137.41,423.45 -520.44,446.7 -1142.55,298.14 -622.11,-148.56 -427.42,-2.18 -1236.64,-519.23 -809.22,-517.05 68.99,-1123.13 984.85,-863.01zm905.76 535.49c-205.49,-175.8 -505.4,-332.89 -944.82,-457.69 -357.99,-101.67 -706.82,-58.74 -928.39,60.34 -80.07,43.03 -142.46,95.52 -180.99,153.88 -37.24,56.41 -52.69,119.08 -40.56,184.63 18.89,102.07 104.12,213.27 276.2,323.21 602.11,384.72 628.29,389.58 868.19,434.09 79.22,14.7 179.68,33.34 329.83,69.19 244.74,58.44 493.9,88.91 690.98,75.93 102.71,-6.76 187.76,-25 244.78,-57 48.31,-27.12 77.7,-67.04 80.71,-122.01 1.54,-28.1 -3.2,-60.15 -14.97,-96.43 -64.86,-199.87 -177.38,-393.99 -380.95,-568.14z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#B2B3B3",
    d: "M877.4 1499.97c247.36,-837.28 538.16,-1183.11 1201.31,-1314.11 663.15,-131 535.51,667.85 392.01,1095.71 -143.5,427.86 -316.37,764.49 -822.52,1132.52 -506.14,368.03 -1018.17,-76.83 -770.81,-914.12zm496.59 -838.38c-173.77,193.32 -300.71,474.28 -419,874.65 -72.42,245.13 -73.15,448.79 -25.73,599.46 29.8,94.69 79.06,169.03 141.42,219.53 63.84,51.69 141.73,79.03 227.13,78.45 97.43,-0.66 204.75,-37.75 312.91,-116.4 243.73,-177.22 406.07,-345.18 523.85,-519.02 116.84,-172.45 191.83,-354.06 260.25,-558.05 70.18,-209.27 136.89,-511.41 94.84,-724.29 -10.41,-52.7 -27.89,-99.22 -54.37,-135.83 -26.49,-36.62 -63.01,-64.77 -111.78,-81.12 -60.16,-20.17 -137.77,-23.12 -236.35,-3.65 -315.08,62.24 -540,173.62 -713.18,366.29z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#B2B3B3",
    fillRule: "nonzero",
    d: "M867.55 1388.66c24.47,-13.88 59.31,-10.25 77.82,8.1 18.5,18.35 13.67,44.48 -10.8,58.36l-67.01 -66.47zm-726.94 412.26l726.94 -412.26 67.01 66.47 -726.94 412.26 -67.01 -66.47zm67.01 66.47c-24.47,13.88 -59.31,10.25 -77.82,-8.1 -18.5,-18.35 -13.67,-44.48 10.8,-58.36l67.01 66.47z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#B2B3B3",
    fillRule: "nonzero",
    d: "M3191.3 714.48c30.31,-3.56 58.74,11.98 63.48,34.71 4.75,22.73 -15.97,44.05 -46.28,47.61l-17.2 -82.32zm-624.94 73.44l624.94 -73.44 17.2 82.32 -624.94 73.44 -17.2 -82.32zm17.2 82.32c-30.31,3.56 -58.74,-11.98 -63.48,-34.71 -4.75,-22.73 15.97,-44.05 46.28,-47.61l17.2 82.32z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#B2B3B3",
    fillRule: "nonzero",
    d: "M2132.25 1986.24c-8.12,-22.19 9.28,-45.12 38.86,-51.21 29.58,-6.09 60.16,6.96 68.28,29.14l-107.15 22.07zm317.1 866.13l-317.1 -866.13 107.15 -22.07 317.1 866.13 -107.15 22.07zm107.15 -22.07c8.12,22.19 -9.28,45.12 -38.86,51.21 -29.58,6.09 -60.16,-6.96 -68.28,-29.14l107.15 -22.07z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#6FB5B4",
    transform: "matrix(0.380868 0.517938 -0.942512 0.724773 629.164 788.59)",
    rx: 252.82,
    ry: 219.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#6FB5B4",
    transform: "matrix(0.310379 0.838535 -1.50364 0.408788 1494.03 528.874)",
    rx: 252.82,
    ry: 219.5
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#6FB5B4",
    transform: "matrix(0.923089 0.387666 -0.325101 0.844096 2556.57 881.845)",
    rx: 368.45,
    ry: 295.93
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#7E71B1",
    cx: 1802.6,
    cy: 1097.53,
    rx: 401.29,
    ry: 336.11
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#6FB5B4",
    cx: 2116.55,
    cy: 1904,
    rx: 417.35,
    ry: 407.64
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#6FB5B4",
    transform: "matrix(0.783632 0.408153 -0.55843 0.876145 953.529 1436.83)",
    rx: 393.93,
    ry: 372.37
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#6FB5B4",
    transform: "matrix(0.980656 0.195737 -0.195737 0.980656 2236.19 267.545)",
    rx: 254.78,
    ry: 115.63
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#6FB5B4",
    transform: "matrix(0.57001 -0.395474 0.890677 0.905602 3199.9 755.645)",
    rx: 164.63,
    ry: 152.87
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#6FB5B4",
    transform: "matrix(1.07764 -0.0232697 0.189689 0.963443 3078.2 1684.02)",
    rx: 239.1,
    ry: 309.65
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#6FB5B4",
    transform: "matrix(1.00743 0.283091 -0.279993 0.903086 174.112 1834.15)",
    rx: 158.72,
    ry: 245.7
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#6FB5B4",
    cx: 1177.43,
    cy: 2415.09,
    rx: 327.3,
    ry: 334.17
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#4D897C",
    cx: 488.9,
    cy: 2540.04,
    rx: 169.48,
    ry: 202.66
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#4D897C",
    cx: 1616.96,
    cy: 3061.03,
    rx: 208.93,
    ry: 212.52
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#6FB5B4",
    transform: "matrix(1.03174 0.177041 -0.183116 0.971074 2502.92 2841.34)",
    rx: 243.01,
    ry: 269.02
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#4D897C",
    cx: 3217.6,
    cy: 2377.74,
    rx: 166.79,
    ry: 198.17
  }), /*#__PURE__*/React.createElement("ellipse", {
    fill: "#4D897C",
    transform: "matrix(0.857369 -0.561266 0.561266 0.857369 3486.69 1377.28)",
    rx: 105.73,
    ry: 166.05
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMilleisoleLogo);
export default __webpack_public_path__ + "static/media/milleisole-logo.c2ff1948216bcc9b2f630f2d18057f55.svg";
export { ForwardRef as ReactComponent };